(function ($, Drupal, drupalSettings) {
  'use strict';
  Drupal.behaviors.tc_brick_border = {
    attach: function (context, settings) {
      $(document).ready(function () {
        resize_borders();
      });

      $(window).on('resize', function () {
        resize_borders();
      });

      function resize_borders() {
        var window_width = $(window).width();
        var target_width = (window_width < 768) ? 27 : (30 * 27 / 26);

        var remaining_width = window_width % target_width;
        var number_of_bricks = (window_width - remaining_width) / target_width;

        var new_brick_width = target_width + (remaining_width / number_of_bricks);

        $('.brick-border').css('background-size', new_brick_width);
      }
    }
  };

})(jQuery, Drupal, drupalSettings);



